import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { NavButton } from 'components/Button'
import { DeepLinkCard } from 'components/Card'

const DeepLinkTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <DeepLinkCard />
      <Spacer size={40} />
      <NavButton label={'店舗アカウント設定に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/account'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default DeepLinkTemplate
